import { ReactNode, useState } from "react";

import { useOpsStore } from "@/features/ops/model/opsStore";

interface Props {
  children: ReactNode;
}

export function OpsTokenGate({ children }: Props) {
  const token = useOpsStore((s) => s.token);
  const setToken = useOpsStore((s) => s.setToken);
  const clear = useOpsStore((s) => s.clear);
  const [input, setInput] = useState("");

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <div className="w-full max-w-sm space-y-4 rounded-lg border bg-card p-6 shadow-sm">
          <h1 className="text-lg font-semibold">Ops panel</h1>
          <p className="text-sm text-muted-foreground">Enter the ops token to continue.</p>
          <input
            type="password"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Token"
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
          <button
            onClick={() => input && setToken(input)}
            disabled={!input}
            className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      {children}
      <button
        onClick={clear}
        className="fixed bottom-4 right-4 rounded-md border border-input bg-background px-3 py-2 text-xs hover:bg-surface-sunken"
      >
        Clear token
      </button>
    </div>
  );
}
